import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import LineGlobeAltIcon from 'LuxKit/Icons/line/LineGlobeAltIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { useContext } from 'react'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import CharterBundleLearnMoreModal from './CharterBundleLearnMoreModal'
import LineCalendarCheckIcon from 'LuxKit/Icons/line/LineCalendarCheckIcon'
import LineClockWithTickIcon from 'LuxKit/Icons/line/LineClockWithTickIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import Heading from 'LuxKit/Typography/Heading'
import TextLink from 'LuxKit/TextLink'

function CharterBundleUSPs() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const flightHighlightsLabel = intl.formatMessage({
    id: '9FKAzxq2oOj1rzolG4wT',
    defaultMessage: 'Flight highlights',
    description: 'Heading for charter bundle flight USPs section on offer page',
  })

  const learnMoreLabel = intl.formatMessage({
    id: 's2PIjzozz75t5W7CqhlW',
    defaultMessage: 'Learn more',
    description: 'Link text to open the charter bundle learn more modal',
  })

  const showLearnMoreModal = () => {
    showModal(<CharterBundleLearnMoreModal />)
  }

  return <Group direction="vertical" gap={12}>
    <Heading variant="heading6">{flightHighlightsLabel}</Heading>
    <Group direction="vertical" gap={4}>
      <BodyTextBlock variant="medium" startIcon={<LineGlobeAltIcon />}>
        <FormattedMessage
          id="TWHz5vNNGnFd0LEjifF8"
          defaultMessage="<b>Australia’s only direct flights</b> to the Maldives."
          description="USP highlighting Australia's exclusive direct flights to the Maldives"
          values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
        />
      </BodyTextBlock>
      <BodyTextBlock variant="medium" startIcon={<LineStarIcon />}>
        <FormattedMessage
          id="1uQRPwbm-MDskcJyXBeD"
          defaultMessage="<b>Luxury Escapes Exclusive Service</b> aboard an A330-200 aircraft."
          description="Offer-page flight benefit naming the Luxury Escapes Exclusive Service and aircraft type"
          values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
        />
      </BodyTextBlock>
      <BodyTextBlock variant="medium" startIcon={<LinePlaneDepartureIcon />}>
        <FormattedMessage
          id="0CoyhzrnEPRHk4aI3O_w"
          defaultMessage="<b>Save up to 20 hours in transit</b> when you fly direct from Melbourne."
          description="USP highlighting time saved by flying direct from Melbourne to the Maldives"
          values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
        />
      </BodyTextBlock>
      <BodyTextBlock variant="medium" startIcon={<LineCalendarCheckIcon />}>
        <FormattedMessage
          id="nMqiIOStUmfZeCmzpoko"
          defaultMessage="<b>Free cancellation</b> within 7 days, and flexible date change options. Conditions apply."
          description="USP highlighting free cancellation policy for charter bundle flights"
          values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
        />
      </BodyTextBlock>
      <BodyTextBlock variant="medium" startIcon={<LineClockWithTickIcon />}>
        <FormattedMessage
          id="VvXKwZ7H28G_IxRCfrSZ"
          defaultMessage="<b>Early arrival and late departure</b> give you extra time to enjoy the Maldives."
          description="USP highlighting the Maldives charter bundle arrival and departure schedule"
          values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
        />
      </BodyTextBlock>
    </Group>
    <CSSBreakpoint max="tablet">
      <TextButton kind="tertiary" horizontalOutdent="start" onClick={showLearnMoreModal}>{learnMoreLabel}</TextButton>
    </CSSBreakpoint>
    <CSSBreakpoint min="desktop">
      <TextLink size="medium" onClick={showLearnMoreModal}>{learnMoreLabel}</TextLink>
    </CSSBreakpoint>
  </Group>
}

export default CharterBundleUSPs
